// extracted by mini-css-extract-plugin
module.exports = {"credit":"style_credit__yKslQ"};